import { c as _c } from "react/compiler-runtime";
import { SnackbarSeverity } from "@website/ui/snackbar-v2";
import { TelesalesAppName } from "@website/widget/telesales/types";
import toNumber from "lodash-es/toNumber";
import { useState } from "react";
export const useTelesales = (storageKey, app) => {
  const $ = _c(10);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSubmitBefore, setIsSubmitBefore] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [snackbar, setSnackbar] = useState(t0);
  let t1;
  if ($[1] !== storageKey) {
    t1 = () => {
      setIsOpenModal(true);
      const timestamp = toNumber(localStorage.getItem(storageKey));
      setIsSubmitBefore(Boolean(timestamp) && Date.now() - timestamp <= 10800000);
    };
    $[1] = storageKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSnackbar({
        title: "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0634\u0645\u0627 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u062B\u0628\u062A \u0634\u062F.",
        severity: "success"
      });
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSubmitSuccess = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSnackbar({
        title: ""
      });
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onCloseSnackbar = t3;
  let t4;
  if ($[5] !== handleOpenModal || $[6] !== isOpenModal || $[7] !== isSubmitBefore || $[8] !== snackbar) {
    t4 = {
      isOpenModal,
      setIsOpenModal,
      handleOpenModal,
      isSubmitBefore,
      snackbar,
      onSubmitSuccess,
      onCloseSnackbar
    };
    $[5] = handleOpenModal;
    $[6] = isOpenModal;
    $[7] = isSubmitBefore;
    $[8] = snackbar;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};